import * as React from 'react'

export const pagination = () => {
  return (
    <>
      <nav className="pagination ls-container">
        <div className="pagination__inner">
        <ul className="pagination__list">
        <li className="pagination__item pagination__item--prev">
          <button className="pagination__button pagination__button--prev">Previous</button>
        </li>
        <li className="pagination__item">
          <button className="pagination__button">1</button>
        </li>
        <li className="pagination__item pagination__item--current">
          <button className="pagination__button">2</button>
        </li>
        <li className="pagination__item pagination__item--spacer">...</li> 
        <li className="pagination__item">
          <button className="pagination__button">9</button>
        </li>
        <li className="pagination__item">
          <button className="pagination__button">10</button>
        </li>
        <li className="pagination__item pagination__item--next">
          <button className="pagination__button pagination__button--next link">Next</button>
        </li>
        </ul>
        </div>
      </nav>
    </>
  )}